/*
 * Utility to combine multiple context providers into a single context provider
 */

import React from 'react';
import { AuthContextProvider } from './AuthContext';
import { CurrentDeviceContextProvider } from './CurrentDeviceContext';
import { DialogBoxContextProvider } from './DialogBoxContext';
import { SocketContextProvider } from './SocketContext';

const combineComponents = (...components) => (
  components.reduce((AccumulatedComponents, CurrentComponent) => (
      ({ children }) =>
        <AccumulatedComponents>
          <CurrentComponent>
            { children }
          </CurrentComponent>
        </AccumulatedComponents>
    ),
    ({ children }) => children
  ));

// Context providers to be combined
const providers = [
  AuthContextProvider,
  DialogBoxContextProvider,
  CurrentDeviceContextProvider,
  SocketContextProvider
];

export const AppContextProvider = combineComponents(...providers);
